module.exports = __webpack_public_path__ + "img/30081939.b6b16307.png";